import type { SVGProps } from 'react'

const SvgDownloadGrey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 11.2885L3.73075 7.01925L4.78475 5.93475L7.25 8.4V0H8.75V8.4L11.2153 5.93475L12.2693 7.01925L8 11.2885ZM2.30775 15C1.80258 15 1.375 14.825 1.025 14.475C0.675 14.125 0.5 13.6974 0.5 13.1923V10.4808H2V13.1923C2 13.2692 2.03208 13.3398 2.09625 13.4038C2.16025 13.4679 2.23075 13.5 2.30775 13.5H13.6923C13.7692 13.5 13.8398 13.4679 13.9038 13.4038C13.9679 13.3398 14 13.2692 14 13.1923V10.4808H15.5V13.1923C15.5 13.6974 15.325 14.125 14.975 14.475C14.625 14.825 14.1974 15 13.6923 15H2.30775Z"
      fill="#5E5E5E"
    />
  </svg>
)

export default SvgDownloadGrey
